export type DocsIndexItem = {
  title: string;
  href: string;
  keywords?: string[];
};

export const DOCS_INDEX: DocsIndexItem[] = [
  {
    title: "What is CompuBio?",
    href: "/docs",
    keywords: ["introduction", "overview", "platform"],
  },
  {
    title: "Getting Started",
    href: "/docs/getting-started",
    keywords: ["signup", "upload", "pipeline"],
  },
  {
    title: "Dashboard Overview",
    href: "/docs/dashboard",
    keywords: ["dashboard", "jobs", "results"],
  },
  {
    title: "Bacteria Analysis",
    href: "/docs/analysis/bacteria",
    keywords: ["bacteria", "kraken2", "bracken"],
  },
  {
    title: "Microbial Analysis",
    href: "/docs/analysis/microbial",
    keywords: ["microbial", "abundance"],
  },
  {
    title: "Diversity Analysis",
    href: "/docs/analysis/diversity",
    keywords: ["alpha", "beta", "pcoa"],
  },
  {
    title: "GWAS",
    href: "/docs/analysis/gwas",
    keywords: ["association", "manhattan", "qq"],
  },
  {
    title: "FAQ",
    href: "/docs/analysis/faq",
    keywords: ["faq", "questions"],
  },
];
